import { useMutateDownload } from "shared/services/base.service";
const BaseServicePath = process.env.REACT_APP_API_REPORT_JAVA;

const DailyInventoryApiService = () => ({
  useDownloadDailyInventoryReportMutation: () => {
    const { mutate } = useMutateDownload({
      invalidateKeys: [],
    });
    return async (body, pathReport) => {
      return await mutate({
        url: `${BaseServicePath}/${pathReport}/report`,
        method: "POST",
        data: body,
      });
    };
  },
});

export const { useDownloadDailyInventoryReportMutation } = DailyInventoryApiService();
